import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Styles from './CloseIcon.styles';
import { BLACK } from '../../../constants/colors';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const Bar = styled.div`${Styles.bar}`; // prettier-ignore

/**
 * CloseIcon Component
 * @param {numer} props.size - close icon width and height
 * @param {string} props.color - close icon color
 * @param {number} props.thick - bar thickness
 * @param {number} props.className - modifier class name
 * @returns {JSX}
 */
const CloseIcon = ({
  size, color, thick, className
}) => {
  return (
    <Wrapper size={size} className={className}>
      <Bar color={color} thick={thick} size={size} />
      <Bar color={color} thick={thick} size={size} isLast />
    </Wrapper>
  );
};

CloseIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  thick: PropTypes.number,
  color: PropTypes.string
};

CloseIcon.defaultProps = {
  size: 20,
  thick: 4,
  color: BLACK
};

export default CloseIcon;
